export default __webpack_public_path__ + "static/media/github-background.7fa45dda.svg";